import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { API_URL, config, UserCode } from '../../../components/Include';
import { Alerts } from '../../../components/notify';
import './change-skill.css';

import Select from 'react-select'
import { styles } from '../../../components/GlobalFunction';

// Render the dropdown menu on top of the page so the container's overflow:hidden
// can't clip it, and let long course names wrap instead of being cut off.
const courseSelectStyles = {
  ...styles,
  control: (css: any) => ({ ...css, minHeight: 45 }),
  valueContainer: (css: any) => ({ ...css, whiteSpace: 'normal' }),
  singleValue: (css: any) => ({ ...css, whiteSpace: 'normal', overflow: 'visible', textOverflow: 'clip' }),
  option: (css: any) => ({ ...css, whiteSpace: 'normal', wordBreak: 'break-word' }),
  menuPortal: (css: any) => ({ ...css, zIndex: 99999 }),
  menuList: (css: any) => ({ ...css, maxHeight: 300 }),
};



const ChangeCourse = () => {
  // State management

  const [loading, setLoading] = useState(false);
  const [activePaymentMethod, setActivePaymentMethod] = useState<string>('Paystack');
  const [changeSkillFee] = useState<number>(1000);
  const [calculatedAmount, setCalculatedAmount] = useState(0);
  const [courses, setCourses] = useState([] as any);
  const [newCourse, setNewCourse] = useState([] as any);

  // Get student data from Redux store
  const student = useSelector((state: any) => state.rootReducer.student);
  const [list, setList] = useState({
    course_code:[] as any,
    new_course_code:[] as any,
  });
 


  const FetchHistory = () => {
    setLoading(true);
    const url = API_URL + '/student/course_record/' + UserCode
    
    axios.get(url, config)
      .then((response:any) => {

        if (response.data.status === 200) {
          const filteredCourses = response.data.data.filter((course:any) => course.course_status === 'Active');
          setCourses(filteredCourses);
        }
      })
      .catch((error) => {
        Alerts('danger', error.message, 'Something went wrong!');
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const fetchCourses = async()=>{

    let url = API_URL+'/students/courses'
      await  axios.get(url,  config).then((result:any)=>{

        if(Array.isArray(result.data.data)){
          setNewCourse(result.data.data)
        }
        })
        .catch(()=>{
         //ErrorModal('oops', error.message)
        })
      }


  const handleSelect = (option:any, action:any)=>{

    setList({...list, [action.name]:option});

  
     }



 

  const handlePaystackFees =()=>{
    var amount = 0
    var amountToCharge = (0.015 * Number(changeSkillFee)) + 300
if(Number(changeSkillFee) <2500){

    amount =  (Number(changeSkillFee)+ (amountToCharge)) * 100

}else if(amountToCharge>2000){
        amount = (Number(changeSkillFee)+ (2000)) * 100
    }else{
        
    amount =  (Number(changeSkillFee)+ (amountToCharge+100)) * 100
    }
    return amount;
}


  const handleFlutterwaveFees = () => {
    const amountToCharge = (0.038 * changeSkillFee);
    const amount = (changeSkillFee + amountToCharge);
    return amount;
  };
  
  
  let amountToPay = activePaymentMethod === 'Paystack' ? handlePaystackFees() : handleFlutterwaveFees();
  const txRef = (new Date()).getTime().toString();
  
  
  useEffect(() => {
    const newAmount = activePaymentMethod === 'Paystack' ? handlePaystackFees() : handleFlutterwaveFees();
    setCalculatedAmount(newAmount);
  }, [activePaymentMethod, changeSkillFee]);
  
  
  useEffect(() => {
    if (calculatedAmount > 0) {
      amountToPay = calculatedAmount;
    }
  }, [calculatedAmount]);
  
  


  const handleChangeCourse = ( ) => {


    if(!list.course_code.value || !list.new_course_code.value){
      Alerts('danger', 'Please select both courses', 'Something went wrong');
      return;
    }


    if(list.course_code.value === list.new_course_code.value){
      Alerts('danger', 'You cannot change to the same course', 'Something went wrong');
      return;
    }

    setLoading(true);
      const fd = new FormData();
     
fd.append('student_code', String(UserCode));
fd.append('old_course', list.course_code.value);
fd.append('new_course', list.new_course_code.value);


      let url = API_URL+'/student/change-course';
        axios.post(url, fd, config).then((response:any)=>{
          
          if(response.data.status ===200){
            setLoading(false);
      Alerts('success', response.data.message, 'Success')
   

          }else{
            Alerts('danger', response.data.message, 'Something went wrong')
            setInterval(()=>{
             window.location.reload();
            }, 3000)
          }
        })
        .catch((error)=>{
          Alerts('danger', error.message, 'Error')
          setInterval(()=>{
            //window.location.reload();
          }, 3000)
        }).finally(()=>{
          setLoading(false);
        }) 
      
  };

  
  
  

  

  useEffect(()=>{
    FetchHistory();
    fetchCourses();
  },[])







  return (
    <>
      {loading && (
        <div className="overlay">
          <img src="/images/loader.svg" alt="Loading" />
        </div>
      )}
      

<div className='alert alert-primary  ' style={{marginTop:'20px'}}>
  <p>Incase you choose the wrong course, use this page to update it </p>

</div>


 <div className="skills-container  mt-4">
        
        <div className="skills-header">
          <h4>
            <i className="fa fa-briefcase me-2"></i> Change Course
          </h4>
        </div>

        <div className="skills-content" style={{ minHeight:'300px'}}>

        <section className="col-md-12 ">
 
 <div  className="form-group">
     <label className='text-bold mb-2'>I Registered For <span className='text-danger'>*</span></label>

 
<Select  options={
              courses&&courses.map((list:any, idx:number)=> {
              return {key:idx, value: list.code, title:list.title, fees:list.fees, skill_code:list.skill_code, label: list.course_title, course_code:list.course_code, session:list.session}
              })} 
              getOptionLabel={option =>`${option.session} ${option.label} - ${option.course_code}`}
onChange={handleSelect}  
name="course_code"
value={list.course_code} 
styles={courseSelectStyles}
menuPortalTarget={document.body}
menuPosition="fixed"
/>
</div>

</section>




<section className="col-md-12 ">
 
 <div  className="form-group">
     <label className='text-bold mb-2'>Instead Of <span className='text-danger'>*</span></label>

 
<Select  options={
              newCourse&&newCourse.map((list:any, idx:number)=> {
              return {key:idx, value: list.code, title:list.title, fees:list.fees, skill_code:list.skill_code, label: list.course_title, course_code:list.course_code, session:list.session}
              })} 
              getOptionLabel={option =>`${option.session} ${option.label} - ${option.course_code}`}
onChange={handleSelect}  
name="new_course_code"
value={list.new_course_code} 
styles={courseSelectStyles}
menuPortalTarget={document.body}
menuPosition="fixed"
/>
</div>

</section>



<button onClick={handleChangeCourse}
            className="btn btn-success"
          >
            <i className="fa fa-info"></i>
            Update Record
          </button>
        </div>
      </div>


    </>
  );
};

export default ChangeCourse;
